// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `._1y6v2qu0 {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  background-color: rgba(0,0,0,0.2);
  display: flex;
  z-index: var(--_18w76bw57);
  align-items: center;
  justify-content: center;
}
._1y6v2qu1 {
  width: 100vw;
  max-width: 375px;
  max-height: 100vh;
  overflow-y: auto;
  margin: 0 auto;
  padding: 0;
  border-radius: var(--_18w76bw4p);
  background-color: transparent;
}
._1y6v2qu2 {
  max-width: 280px;
}
._1y6v2qu3 {
  max-width: 375px;
}
._1y6v2qu4 {
  max-width: 460px;
}
._1y6v2qu5 {
  max-width: 500px;
}
._1y6v2qu6 {
  max-width: 600px;
}
._1y6v2qu7 {
  max-width: 800px;
}
._1y6v2qu8 {
  width: 100vw;
  max-width: 100vw;
  min-height: 100vh;
}
._1y6v2qu9 {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
}
._1y6v2qua {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
}
._1y6v2qub {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
}
._1y6v2quc {
  height: 100vh;
  max-width: 100vw;
}
._1y6v2qud {
  height: 100%;
  width: 100vw;
  max-width: 100vw;
}
._1y6v2que {
  width: 100vw;
  max-width: 100vw;
  overflow-x: hidden;
  height: 100vh;
}
._1y6v2quf {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
}
._1y6v2qug {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
}
._1y6v2quh {
  width: 100vw;
  max-width: 100vw;
  height: 100vh;
}
@media screen and (max-width: 767px) {
  ._1y6v2quf {
    max-width: 860px;
    height: auto;
  }
}
@media screen and (min-width: 768px) {
  ._1y6v2qu9 {
    max-width: 600px;
    height: auto;
  }
  ._1y6v2qua {
    max-width: 500px;
    height: auto;
  }
  ._1y6v2qub {
    max-width: 375px;
    height: auto;
  }
  ._1y6v2quc {
    max-width: 600px;
    height: auto;
  }
  ._1y6v2que {
    max-width: 800px;
    height: auto;
  }
  ._1y6v2quf {
    max-width: 860px;
    margin-top: 10px;
    height: auto;
  }
  ._1y6v2qug {
    max-width: 540px;
    height: auto;
  }
  ._1y6v2quh {
    max-width: 560px;
    height: auto;
    margin: auto;
  }
  ._1y6v2qui {
    max-width: 125px;
  }
  ._1kj8ryw1 + div ._1y6v2qui {
    max-width: 250px;
  }
}
@media screen and (min-width: 1024px) {
  ._1y6v2qu1 {
    margin: 150px auto auto auto;
    align-self: flex-start;
  }
  ._1y6v2qu4 {
    margin: auto;
  }
  ._1y6v2quc {
    margin: auto;
  }
  ._1y6v2quf {
    margin: 50px auto auto auto;
    align-self: flex-start;
  }
  ._1y6v2quh {
    margin: auto;
  }
}`, "",{"version":3,"sources":["webpack://./../../node_modules/@vanilla-extract/webpack-plugin/extracted.js"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,OAAO;EACP,QAAQ;EACR,SAAS;EACT,MAAM;EACN,iCAAiC;EACjC,aAAa;EACb,0BAA0B;EAC1B,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,UAAU;EACV,gCAAgC;EAChC,6BAA6B;AAC/B;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,aAAa;EACb,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE,YAAY;EACZ,gBAAgB;EAChB,aAAa;AACf;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;AACF;AACA;EACE;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;EACd;EACA;IACE,gBAAgB;IAChB,YAAY;IACZ,YAAY;EACd;EACA;IACE,gBAAgB;EAClB;EACA;IACE,gBAAgB;EAClB;AACF;AACA;EACE;IACE,4BAA4B;IAC5B,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;EACA;IACE,YAAY;EACd;EACA;IACE,2BAA2B;IAC3B,sBAAsB;EACxB;EACA;IACE,YAAY;EACd;AACF","sourcesContent":["._1y6v2qu0 {\n  position: fixed;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  top: 0;\n  background-color: rgba(0,0,0,0.2);\n  display: flex;\n  z-index: var(--_18w76bw57);\n  align-items: center;\n  justify-content: center;\n}\n._1y6v2qu1 {\n  width: 100vw;\n  max-width: 375px;\n  max-height: 100vh;\n  overflow-y: auto;\n  margin: 0 auto;\n  padding: 0;\n  border-radius: var(--_18w76bw4p);\n  background-color: transparent;\n}\n._1y6v2qu2 {\n  max-width: 280px;\n}\n._1y6v2qu3 {\n  max-width: 375px;\n}\n._1y6v2qu4 {\n  max-width: 460px;\n}\n._1y6v2qu5 {\n  max-width: 500px;\n}\n._1y6v2qu6 {\n  max-width: 600px;\n}\n._1y6v2qu7 {\n  max-width: 800px;\n}\n._1y6v2qu8 {\n  width: 100vw;\n  max-width: 100vw;\n  min-height: 100vh;\n}\n._1y6v2qu9 {\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n}\n._1y6v2qua {\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n}\n._1y6v2qub {\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n}\n._1y6v2quc {\n  height: 100vh;\n  max-width: 100vw;\n}\n._1y6v2qud {\n  height: 100%;\n  width: 100vw;\n  max-width: 100vw;\n}\n._1y6v2que {\n  width: 100vw;\n  max-width: 100vw;\n  overflow-x: hidden;\n  height: 100vh;\n}\n._1y6v2quf {\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n}\n._1y6v2qug {\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n}\n._1y6v2quh {\n  width: 100vw;\n  max-width: 100vw;\n  height: 100vh;\n}\n@media screen and (max-width: 767px) {\n  ._1y6v2quf {\n    max-width: 860px;\n    height: auto;\n  }\n}\n@media screen and (min-width: 768px) {\n  ._1y6v2qu9 {\n    max-width: 600px;\n    height: auto;\n  }\n  ._1y6v2qua {\n    max-width: 500px;\n    height: auto;\n  }\n  ._1y6v2qub {\n    max-width: 375px;\n    height: auto;\n  }\n  ._1y6v2quc {\n    max-width: 600px;\n    height: auto;\n  }\n  ._1y6v2que {\n    max-width: 800px;\n    height: auto;\n  }\n  ._1y6v2quf {\n    max-width: 860px;\n    margin-top: 10px;\n    height: auto;\n  }\n  ._1y6v2qug {\n    max-width: 540px;\n    height: auto;\n  }\n  ._1y6v2quh {\n    max-width: 560px;\n    height: auto;\n    margin: auto;\n  }\n  ._1y6v2qui {\n    max-width: 125px;\n  }\n  ._1kj8ryw1 + div ._1y6v2qui {\n    max-width: 250px;\n  }\n}\n@media screen and (min-width: 1024px) {\n  ._1y6v2qu1 {\n    margin: 150px auto auto auto;\n    align-self: flex-start;\n  }\n  ._1y6v2qu4 {\n    margin: auto;\n  }\n  ._1y6v2quc {\n    margin: auto;\n  }\n  ._1y6v2quf {\n    margin: 50px auto auto auto;\n    align-self: flex-start;\n  }\n  ._1y6v2quh {\n    margin: auto;\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
